import { render, staticRenderFns } from "./AssignPersonModal.vue?vue&type=template&id=23d6c8d1&scoped=true"
import script from "./AssignPersonModal.vue?vue&type=script&lang=js"
export * from "./AssignPersonModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d6c8d1",
  null
  
)

export default component.exports